import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '../../hooks/useUser';
import UserList from './UserList';
import Branches from './branches';
import Categories from './categories';
import Evaluations from './evaluations';
import Feedback from './feedback';
import Mevos from './mevos';
import Progress from './progress';
import Subjects from './subjects';
import Topics from './topics';
import CohortsAdminPage from '../../features/mfa/admin/pages/CohortsAdminPage';
import AuditLogAdminPage from '../../features/mfa/admin/pages/AuditLogAdminPage';

type SubPageProps = {
  location: string;
};

const SubPage = (props: SubPageProps) => {
  const { location } = props;
  switch (location) {
    case 'users':
      return <UserList />;
    case 'progress':
      return <Progress />;
    case 'statistics':
      return <p>Not implemented</p>;
    case 'topics':
      return <Topics />;
    case 'subjects':
      return <Subjects />;
    case 'categories':
      return <Categories />;
    case 'feedback':
      return <Feedback />;
    case 'mevos':
      return <Mevos />;
    case 'branches':
      return <Branches />;
    case 'evaluations':
      return <Evaluations />;
    case 'cohorts':
      return <CohortsAdminPage />;
    case 'auditlog':
      return <AuditLogAdminPage />;
    default:
      return <p>Not implemented</p>;
  }
};

const AdminPanelMainContent = () => {
  const params = useParams();
  const navigate = useNavigate();
  const userQuery = useUser();

  if (!userQuery.isSuccess) {
    return null;
  }

  if (
    userQuery.data.role !== 'ADMIN' &&
    userQuery.data.role !== 'SUPER_ADMIN'
  ) {
    navigate('/');
  }

  // `flex` was missing here — `flex-col` alone does nothing in block flow, so
  // nothing below could ever stretch vertically. With it (plus flex-1) the
  // sub-page fills the remaining viewport height instead of leaving ~1000px of
  // white space under a short table.
  return (
    <main className="w-full flex flex-col flex-1 space-y-3 mt-6 min-h-0">
      {/* was `to-teal-500` — `teal` is not in the palette (the theme replaces
          Tailwind's colours wholesale), so the gradient had no end colour and
          silently rendered as a flat fill. `aqua` is the brand's companion to
          `sky`. Spacing tightened because the tab strip now sits directly
          above this heading; mt-8/mb-10 left it stranded. */}
      <h1 className="font-bold text-xl tracking-normal text-transparent bg-clip-text bg-gradient-to-r from-sky to-aqua mb-6">
        {params.tab?.toUpperCase()}
      </h1>
      <div className="flex flex-col flex-1 min-h-0">
        <SubPage location={params.tab as string} />
      </div>
    </main>
  );
};

export default AdminPanelMainContent;
